import helpers from '72cms-ui/helpers';

export default helpers;



// WEBPACK FOOTER //
// ./resources/assets/site/js/helpers.js